module.exports = __webpack_public_path__ + "img/sld_scb_21_t1_b1.8843c056.svg";